"use client";

import React, { useState, useEffect } from 'react';

export const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // Appears exactly after scrolling past 1 full screen height
            if (window.scrollY > window.innerHeight) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-8 left-8 z-50 flex flex-col items-center justify-center w-12 h-12 rounded-full bg-[#e5e9f0]/90 backdrop-blur-sm shadow-md border border-zinc-200/50 text-zinc-700 transition-all duration-300 ease-in-out hover:bg-[#dee4ee] hover:scale-105 active:scale-95 ${isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
                }`}
            aria-label="Back to top"
        >
            {/* Horizontal Line top element */}
            <span className="w-3.5 h-[1.5px] bg-zinc-700 rounded-full mb-[2px]" />

            {/* Chevron Up Arrow */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                stroke="currentColor"
                className="w-4 h-4 text-zinc-700"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
            </svg>
        </button>
    );
};